<template>
  <v-layout row justify-center>
    <v-dialog persistent v-model="dialog" max-width="700">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pl-2">settings</v-icon>
            {{ userData ? 'Edit ' + userData.email : 'Add' }} user
          </span>
          <v-btn absolute left depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form ref="edit_user" data-vv-scope="edit_user" lazy-validation>
            <v-layout v-if="loading" row justify-center py-5 >
              <v-progress-circular
                :size="150"
                :width="7"
                color="blue"
                indeterminate
              ></v-progress-circular>
            </v-layout>
            <v-layout v-else row wrap pb-3>
              <v-flex xs5 style="margin: auto;">
                Email*:
              </v-flex>
              <v-flex xs7>
                <v-text-field
                  autocomplete="off"
                  type="text"
                  v-model="form.email"
                  v-validate="'required|email'"
                  data-vv-name="edit_user.email"
                  :error-messages="errors.collect('edit_user.email')"
                  v-on:keyup.enter="registerEmail()"
                  prepend-icon="email"
                ></v-text-field>
              </v-flex>
              <v-flex xs5 style="margin: auto;">
                Password*:
              </v-flex>
              <v-flex xs7>
                <v-text-field
                  autocomplete="new-password"
                  type="password"
                  :label="userData ? 'If field is empty, password will not be changed' : ''"
                  v-model="form.password"
                  :v-validate=" userData ? '' : 'required'"
                  data-vv-name="edit_user.password"
                  :error-messages="errors.collect('edit_user.password')"
                  v-on:keyup.enter="registerEmail()"
                  required
                  prepend-icon="lock"
                ></v-text-field>
              </v-flex>
              <v-flex xs5 style="margin: auto;">
                Retype Password:
              </v-flex>
              <v-flex xs7 pt-3>
                <v-text-field
                  type="password"
                  v-validate="{ is: form.password }"
                  data-vv-name="edit_user.confirmed"
                  :error-messages="errors.collect('edit_user.confirmed')"
                  v-on:keyup.enter="registerEmail()"
                  required
                  prepend-icon="lock"
                ></v-text-field>
              </v-flex>
              <v-flex xs5 style="margin: auto;">
                Fullname*:
              </v-flex>
              <v-flex xs7 pt-3>
                <v-text-field
                  type="text"
                  v-model="form.fullname"
                  v-validate="'required|min:2'"
                  data-vv-name="edit_user.full_name"
                  :error-messages="errors.collect('edit_user.full_name')"
                  v-on:keyup.enter="registerPhone()"
                  required
                  prepend-icon="person"
                ></v-text-field>
              </v-flex>
              <v-flex xs5 style="margin: auto;">
                Country*:
              </v-flex>
              <v-flex xs7 pt-3>
                <v-autocomplete
                  label="Country"
                  v-model="form.country_code"
                  :items="$store.state.metadata.phoneCodes"
                  v-validate="'required'"
                  data-vv-name="edit_user.country_code"
                  :error-messages="errors.collect('edit_user.country_code')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs5 style="margin: auto;">
                Phone*:
              </v-flex>
              <v-flex xs7 pt-3>
                <v-text-field
                  label="Phone"
                  type="text"
                  v-model="form.phone_number"
                  v-validate="'required'"
                  data-vv-name="edit_user.phone_number"
                  mask="(###) ### - ####"
                  :error-messages="errors.collect('edit_user.phone_number')"
                  v-on:keyup.enter="registerPhone()"
                  required
                  prepend-icon="stay_current_portrait"
                ></v-text-field>
              </v-flex>
              <v-flex xs5 style="margin: auto;">
                Woek in:
              </v-flex>
              <v-flex xs7 pt-3>
                <v-select
                  label="Work in"
                  :items="workInList"
                  v-model="form.work_in"
                  v-validate="'required'"
                  data-vv-name="edit_user.work_in"
                  :error-messages="errors.collect('edit_user.work_in')"
                ></v-select>
              </v-flex>
              <v-flex xs5 style="margin: auto;">
                10Club reports*:
              </v-flex>
              <v-flex xs7 pt-3>
                <template v-for="report in tenClubReportsList">
                  <v-checkbox
                    v-if="report.ten_club"
                    :key="report.id"
                    v-model="form.ten_club_reports"
                    :label="report.description"
                    :value="report.id"
                    class="pt-0 mt-0"
                  ></v-checkbox>
                </template>
              </v-flex>
              <!-- <v-flex xs5 style="margin: auto;">
                Subscription auto renew*:
              </v-flex>
              <v-flex xs7 pt-3>
                <v-checkbox
                  v-model="form.subscription_renew"
                  label="Renew subscription every month?"
                  class="pt-0 mt-0"
                ></v-checkbox>
              </v-flex> -->
              <v-flex xs5 style="margin: auto;">
                <span v-if="userData">User Status:</span>
                <span v-else>Activate:</span>
              </v-flex>
              <v-flex xs7 pt-3>
                <v-select
                  v-if="userData"
                  label="Status"
                  :items="$store.state.user.statusesSeletc"
                  v-model="form.status"
                ></v-select>
                <v-checkbox
                  v-else
                  v-model="form.status"
                  label="If not, then user should confirm his email"
                  class="pt-0 mt-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs5 style="margin: auto;">
                Is affiliate:
              </v-flex>
              <v-flex xs7 pt-3>
                <v-checkbox
                  v-model="form.is_affiliate"
                  label="Is affiliate"
                  class="pt-0 mt-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs5 style="margin: auto;">
                Note:
              </v-flex>
              <v-flex xs7 pt-3>
                <v-textarea
                  v-model="form.admin_note"
                  rows="3"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="saveUser()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'UserModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['userDialog', 'userData'],
  data () {
    return {
      dialog: this.userDialog,
      loading: false,
      tenClubReportsList: this.$store.state.metadata.reportsById,
      form: {
        email: this.userData ? this.userData.email : '',
        password: '',
        status: this.userData ? this.userData.status : true,
        fullname: this.userData ? this.userData.fullname : '',
        phone_number: this.userData ? this.userData.phone_number.split(' ')[1] : '',
        country_code: this.userData ? this.userData.phone_number.split(' ')[0] : '',
        work_in: this.userData ? this.userData.work_in : '',
        ten_club_reports: this.userData && this.userData.ten_club_reports ? this.userData.ten_club_reports : [],
        subscription_renew: this.userData && this.userData.subscription_renew ? this.userData.subscription_renew : true,
        admin_note: this.userData && this.userData.admin_note ? this.userData.admin_note : '',
        is_affiliate: this.userData ? this.userData.is_affiliate : false
      },
      rePassword: '', // do not remove this field
      workInList: [
        'Agency',
        'Freelance',
        'In-house SEO',
        'Site owner',
        'Other'
      ],
      countryCodes: [
        {id: '+1', name: 'USA (+1)'},
        {id: '+7', name: 'Russia (+7)'},
        {id: '+33', name: 'France (+33)'}
      ],
      dictionary: {
        en: {
          custom: {
            'edit_user.email': {
              required: 'Enter your E-mail',
              email: 'E-mail not valid'
            },
            'edit_user.name': {
              required: 'Password required',
              min: 'Required at least 2 symbols'
            },
            'edit_user.password': {
              required: 'Password required',
              min: 'Required at least 6 symbols'
            },
            'edit_user.confirmed': {
              is: 'Passwords don\'t match'
            },
            'edit_user.full_name': {
              required: 'Name required',
              min: 'At least two characters'
            },
            'edit_user.country_code': {
              required: 'Please select country'
            },
            'edit_user.phone_number': {
              required: 'Enter your phone number'
            },
            'edit_user.work_in': {
              required: 'Please select where are you working'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    userDialog: {
      handler () {
        this.dialog = this.userDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('userDialog', this.dialog)
      }
    }
  },
  methods: {
    saveUser () {
      this.$validator.validateAll('edit_user').then(res => {
        if (res) {
          this.loading = true
          if (this.userData) {
            let params = {
              status: this.form.status,
              country_code: this.form.country_code,
              work_in: this.form.work_in,
              ten_club_reports: this.form.ten_club_reports || [],
              subscription_renew: this.form.subscription_renew,
              fullname: this.form.fullname,
              is_affiliate: this.form.is_affiliate,
              admin_note: this.form.admin_note
            }
            if (this.form.email !== this.userData.email) params.email = this.form.email
            if (this.form.phone_number !== this.userData.phone_number.split(' ')[1]) params.phone_number = this.form.phone_number
            if (this.form.password) params.password = this.form.password
            this.$store.dispatch('EDIT_USER', { userId: this.userData.id, newData: params }).then(res => {
              this.loading = false
              this.$parent.$emit('updateUsersList')
              this.$toasted.show('User was successfully edited')
              this.closeModal()
            }, err => {
              console.log('EDIT_USER error', err)
              this.loading = false
              let errorText = this.$services.getApiError(err)
              if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
            })
          } else {
            this.$store.dispatch('ADD_USER', this.form).then(res => {
              this.loading = false
              this.$parent.$emit('updateUsersList')
              this.$toasted.show('User was successfully added')
              this.closeModal()
            }, err => {
              console.log('ADD_USER error', err)
              this.loading = false
              this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${this.$services.getApiError(err)}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
            })
          }
        }
      })
    },
    closeModal () {
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/UserModal.vue